<nav class="referent-header">
  <a [routerLink]="homeRoute"> Početna </a>

  @if (supervisorAuthService.isAuthenticate$ | async) {
    <a [routerLink]="supervisorMenuPageRoute"> e-Ovlaštenja - skupno potpisivanje </a>

    <div
      style="cursor: pointer"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="menu"
      id="user-details">
      <nz-icon
        nzType="user"
        nzTheme="outline" />
      {{
        supervisorAuthService.userValue?.FirstName +
          ' ' +
          supervisorAuthService.userValue?.LastName +
          ' - ' +
          supervisorAuthService.userValue?.UserRoles
      }}
      <nz-icon
        nzType="caret-down"
        nzTheme="outline" />
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li
          nz-menu-item
          [routerLink]="supportRoute">
          <nz-icon
            nzType="phone"
            nzTheme="outline" />
          Kontakt podrška
        </li>
        <li nz-menu-divider></li>
        <li
          nz-menu-item
          (click)="openUserInstructions()">
          <nz-icon
            nzType="book"
            nzTheme="outline" />
          Radne upute
        </li>
        <li nz-menu-divider></li>
        <li
          nz-menu-item
          (click)="supervisorAuthService.logout()">
          <nz-icon
            nzType="logout"
            nzTheme="outline" />Odjava
        </li>
      </ul>
    </nz-dropdown-menu>
  } @else {
    <div
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="menu"
      id="user-details">
      <nz-icon
        nzType="user"
        nzTheme="outline" />
      Kontakt podrška
      <nz-icon
        nzType="caret-down"
        nzTheme="outline" />
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li
          nz-menu-item
          [routerLink]="supportRoute">
          <nz-icon
            nzType="phone"
            nzTheme="outline" />
          Kontakt podrška
        </li>
        <li nz-menu-divider></li>
      </ul>
    </nz-dropdown-menu>
  }
</nav>
